import React from 'react'
import CustomSearch from '../components/CustomSearch'

const Predict = () => {
    return (
        <div>
            <CustomSearch/>
        </div>
    )
}

export default Predict
